export const categories = [
  {
    id: 'meishi',
    name: '美食',
    icon: 'ri-restaurant-line',
    description: '探索各地风味美食，从街头小吃到精致料理，用镜头记录舌尖上的甜蜜滋味。',
    image: 'https://readdy.ai/api/search-image?query=warm%20cozy%20food%20photography%20with%20colorful%20fresh%20ingredients%20on%20wooden%20table%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20cream%20background%2C%20warm%20peach%20tones%2C%20editorial%20style%2C%20clean%20aesthetic&width=800&height=600&seq=cat-food-01&orientation=landscape',
    count: 1286,
  },
  {
    id: 'lvxing',
    name: '旅行',
    icon: 'ri-earth-line',
    description: '跟随创作者足迹走遍世界，沉浸式旅行Vlog带你感受不同城市的独特魅力。',
    image: 'https://readdy.ai/api/search-image?query=scenic%20travel%20landscape%20with%20warm%20sunset%20light%2C%20rolling%20hills%20and%20distant%20mountains%2C%20soft%20pastel%20sky%20colors%2C%20minimalist%20travel%20photography%2C%20cream%20and%20peach%20warm%20tones%2C%20serene%20atmosphere&width=800&height=600&seq=cat-travel-01&orientation=landscape',
    count: 953,
  },
  {
    id: 'shishang',
    name: '时尚',
    icon: 'ri-shirt-line',
    description: '紧跟潮流趋势，穿搭灵感、美妆教程、生活美学，打造属于你的甜美风格。',
    image: 'https://readdy.ai/api/search-image?query=elegant%20fashion%20flat%20lay%20with%20soft%20fabric%20textures%20and%20minimal%20accessories%2C%20warm%20neutral%20background%2C%20natural%20light%20from%20window%2C%20peach%20and%20cream%20color%20palette%2C%20editorial%20product%20photography%20with%20soft%20shadows&width=800&height=600&seq=cat-fashion-01&orientation=landscape',
    count: 742,
  },
  {
    id: 'mengchong',
    name: '萌宠',
    icon: 'ri-heart-pulse-line',
    description: '可爱毛孩子的日常，治愈系宠物视频，甜蜜互动温暖你的每一天。',
    image: 'https://readdy.ai/api/search-image?query=adorable%20fluffy%20kitten%20and%20puppy%20playing%20together%20in%20warm%20sunlit%20room%2C%20soft%20cream%20textiles%20background%2C%20natural%20golden%20hour%20lighting%2C%20heartwarming%20pet%20photography%2C%20cozy%20home%20atmosphere%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-pet-01&orientation=landscape',
    count: 1105,
  },
];

export const articles = [
  {
    id: 'article-1',
    title: '夏日蜜桃特饮：三款超高颜值果茶制作教程',
    slug: 'summer-peach-drinks',
    excerpt: '炎炎夏日，一杯清凉的蜜桃特饮就是最好的治愈。今天教大家三款简单又好喝的蜜桃果茶，颜值超高、口感清甜，在家就能轻松复刻网红饮品店的味道。',
    content: `<p>炎炎夏日，最幸福的事莫过于来一杯冰凉爽口的饮品了。蜜桃作为夏季的代表性水果，不仅口感清甜多汁，还富含丰富的维生素和膳食纤维，是制作夏日特饮的绝佳原料。</p>
    <p>今天就来分享三款简单易学、颜值超高的蜜桃特饮，让你在家也能享受网红饮品店的甜蜜滋味。</p>
    <h3>一、蜜桃乌龙奶盖茶</h3>
    <p>这款饮品层次丰富，底部是清甜的蜜桃果肉，中间是淡雅的乌龙茶，顶部是绵密的奶盖，一口下去三种口感交织，让人回味无穷。</p>
    <p>材料：新鲜蜜桃2个、乌龙茶包1袋、淡奶油100ml、牛奶30ml、白砂糖适量、冰块适量。</p>
    <p>做法：将蜜桃去皮切丁，放入杯底捣碎；乌龙茶用热水冲泡后冷却；淡奶油加糖打发至绵密状；杯中依次加入蜜桃果肉、冰块、乌龙茶，最后淋上奶盖即可。</p>
    <h3>二、蜜桃气泡水</h3>
    <p>这款是最简单快手的一款，清爽的气泡搭配蜜桃的香甜，简直是夏天的标配。</p>
    <p>材料：蜜桃1个、气泡水1罐、薄荷叶少许、柠檬片2片、蜂蜜适量。</p>
    <p>做法：蜜桃切片放入杯中，加入蜂蜜和柠檬片轻轻搅拌，倒入冰镇气泡水，最后点缀薄荷叶，简单又好看。</p>
    <h3>三、蜜桃酸奶冰沙</h3>
    <p>喜欢浓郁口感的朋友一定不要错过这款，蜜桃和酸奶的搭配简直绝了。</p>
    <p>材料：冻蜜桃块200g、酸奶150ml、蜂蜜适量、燕麦碎少许。</p>
    <p>做法：将冻蜜桃块、酸奶和蜂蜜一起放入破壁机打至顺滑，倒入杯中，撒上燕麦碎增加口感层次。</p>`,
    category: 'meishi',
    categoryName: '美食',
    author: '蜜桃小厨娘',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20professional%20headshot%20style%2C%20gentle%20expression%2C%20warm%20peach%20tones&width=200&height=200&seq=author-1&orientation=squarish',
    date: '2026-08-08',
    views: 32850,
    likes: 4821,
    image: 'https://readdy.ai/api/search-image?query=three%20beautiful%20peach%20fruit%20drinks%20in%20glass%20cups%20on%20marble%20table%2C%20fresh%20peaches%20and%20mint%20leaves%20as%20decoration%2C%20soft%20morning%20sunlight%20through%20window%2C%20cream%20and%20peach%20color%20palette%2C%20food%20photography%20style%2C%20clean%20composition&width=1200&height=675&seq=article-1&orientation=landscape',
    tags: ['夏日饮品', '蜜桃', 'DIY', '美食教程'],
  },
  {
    id: 'article-2',
    title: '京都深度游攻略：三天两夜感受千年古都的甜蜜慢生活',
    slug: 'kyoto-travel-guide',
    excerpt: '京都，一座被时光温柔对待的城市。在这里，每一个转角都藏着惊喜，每一家小店都有属于自己的故事。跟着蜜桃旅行家一起，用三天时间慢慢感受京都独有的甜蜜与优雅。',
    content: `<p>京都是我去过最让人心动的城市之一。它不像东京那样繁华喧嚣，也不像大阪那样热情奔放，京都的美，是需要慢慢品的。</p>
    <p>这次我花了三天时间，放慢脚步，深入体验京都的每一个角落，整理出这份甜蜜旅行攻略，希望能给你的京都之旅带来一些灵感。</p>
    <h3>Day 1：岚山竹林 & 和服漫步</h3>
    <p>第一天的行程从岚山开始。清晨的岚山竹林人少安静，阳光透过竹叶洒下斑驳的光影，美得让人屏息。推荐早点出发，避开人流高峰。</p>
    <p>中午在岚山附近的豆腐料理店享用京都名物——汤豆腐，清淡中带着豆香，非常适合作为旅途中的一餐。</p>
    <p>下午回到市区，在清水寺附近的和服店换上美丽的和服，沿着二年坂、三年坂慢慢散步，感受江户时代的古都风情。</p>
    <h3>Day 2：伏见稻荷 & 抹茶体验</h3>
    <p>第二天我们去了伏见稻荷大社，千本鸟居的壮观无法用言语形容。红与绿的交织，在晨光中格外夺目。</p>
    <p>下午安排了一场抹茶体验，在传统的茶室里学习如何打一碗地道的抹茶。配上和果子，苦涩与甜蜜交织，是京都最经典的味觉体验。</p>
    <h3>Day 3：锦市场 & 告别</h3>
    <p>最后一天去了被誉为"京都厨房"的锦市场。这里汇集了各种京都特色美食：玉子烧、京渍物、豆乳甜甜圈……每一样都不想错过。</p>
    <p>三天的京都之旅虽然短暂，但每一刻都让人怀念。这就是属于京都的甜蜜慢生活。</p>`,
    category: 'lvxing',
    categoryName: '旅行',
    author: '蜜桃旅行家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20gentle%20smile%2C%20outdoor%20soft%20lighting%2C%20minimalist%20warm%20background%2C%20travel%20photographer%20style%2C%20friendly%20expression%2C%20peach%20warm%20tones&width=200&height=200&seq=author-2&orientation=squarish',
    date: '2026-08-06',
    views: 56210,
    likes: 7832,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20kyoto%20bamboo%20forest%20path%20with%20soft%20morning%20sunlight%20filtering%20through%20trees%2C%20traditional%20japanese%20architecture%20in%20distance%2C%20warm%20golden%20hour%20atmosphere%2C%20serene%20travel%20photography%2C%20cream%20and%20warm%20tones&width=1200&height=675&seq=article-2&orientation=landscape',
    tags: ['京都', '旅行攻略', '日本', '深度游'],
  },
  {
    id: 'article-3',
    title: '2026早秋穿搭趋势：温柔蜜桃色系穿搭指南',
    slug: 'autumn-fashion-peach',
    excerpt: '蜜桃色系作为今年早秋最受瞩目的流行色，温柔又百搭。从穿搭博主的角度为你解析如何将蜜桃色系穿出高级感，打造属于你的秋日甜蜜造型。',
    content: `<p>季节交替之时，衣橱也需要一场温柔的更新。今年早秋，蜜桃色系成为了各大品牌和时尚博主的宠儿，从桃粉色到杏色，从奶茶色到珊瑚橙，这一系列温暖又柔和的色调正在席卷时尚圈。</p>
    <p>今天就来解析一下，如何将蜜桃色系穿出高级感。</p>
    <h3>蜜桃色系的色彩搭配法则</h3>
    <p>蜜桃色系属于暖色调，搭配时遵循"同色系叠加"和"冷暖平衡"两个原则基本不会出错。同色系搭配可以选择不同深浅的蜜桃色进行叠穿，营造层次感；冷暖平衡则可以用米白、奶油色来中和蜜桃色的暖感，整体更加清新。</p>
    <h3>单品推荐</h3>
    <p>入门级推荐从一件蜜桃色的针织衫开始。柔软的针织材质搭配温柔的蜜桃色，简直就是秋日的绝配。搭配一条白色阔腿裤或是米色半裙，轻松打造温柔知性的气质。</p>
    <p>进阶玩家可以尝试蜜桃色的西装外套或是风衣，这个颜色的西装不会太过正式，反而多了几分柔美的女性气质，通勤约会两不误。</p>
    <h3>配饰点睛</h3>
    <p>如果担心大面积蜜桃色不好驾驭，可以从配饰入手。一条蜜桃色丝巾、一款蜜桃色包包，甚至是一双蜜桃色的袜子，都能为整体造型增添一抹温柔。</p>`,
    category: 'shishang',
    categoryName: '时尚',
    author: '蜜桃时尚志',
    authorAvatar: 'https://readdy.ai/api/search-image?query=stylish%20young%20asian%20woman%20portrait%2C%20elegant%20minimal%20style%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20fashionable%20headshot%2C%20warm%20peach%20tones%2C%20confident%20gentle%20expression&width=200&height=200&seq=author-3&orientation=squarish',
    date: '2026-08-05',
    views: 41980,
    likes: 6234,
    image: 'https://readdy.ai/api/search-image?query=elegant%20autumn%20fashion%20flat%20lay%20with%20peach%20colored%20clothing%20and%20accessories%2C%20soft%20cashmere%20sweaters%20and%20scarves%2C%20minimalist%20cream%20background%2C%20warm%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20cozy%20aesthetic&width=1200&height=675&seq=article-3&orientation=landscape',
    tags: ['早秋穿搭', '蜜桃色系', '时尚搭配', '穿搭指南'],
  },
  {
    id: 'article-4',
    title: '喵星人的甜蜜日常：如何打造猫咪最爱的居家环境',
    slug: 'cat-home-environment',
    excerpt: '想让猫咪在家过得更加舒适快乐吗？从猫爬架到玩具选择，从饮食到互动方式，蜜桃萌宠达人分享打造猫咪理想家的全攻略。',
    content: `<p>猫咪是我们生活中最甜蜜的陪伴。作为铲屎官，我们都希望能给毛孩子最好的生活。一个舒适、安全、有趣的居家环境，对于猫咪的身心健康至关重要。</p>
    <p>今天就来分享一些打造猫咪友好型居家环境的小贴士。</p>
    <h3>垂直空间的利用</h3>
    <p>猫咪天生喜欢攀爬和高处。在家里设置猫爬架、墙上猫道或是窗台猫垫，可以给猫咪提供丰富的垂直探索空间。这不仅满足了它们的天性需求，还能防止它们去爬你不希望它们去的地方。</p>
    <h3>舒适的休息区</h3>
    <p>猫咪一天要睡16个小时左右，舒适的休息空间非常重要。除了常规的猫窝，阳光充足的窗台、柔软的毯子和不受打扰的角落都是猫咪最喜欢的午睡地点。</p>
    <h3>互动与玩具</h3>
    <p>每天至少安排15-20分钟的互动游戏时间，使用逗猫棒、激光笔等玩具激发猫咪的捕猎本能。定期轮换玩具可以保持新鲜感，避免猫咪产生厌倦。</p>
    <h3>饮食与环境丰容</h3>
    <p>除了常规的猫粮碗，可以尝试使用漏食球、嗅闻垫等工具，让猫咪通过"工作"来获取食物，这既能消耗精力，又能满足它们的探索需求。</p>`,
    category: 'mengchong',
    categoryName: '萌宠',
    author: '蜜桃喵星人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20woman%20with%20cat%2C%20warm%20friendly%20portrait%2C%20soft%20indoor%20lighting%2C%20cozy%20home%20atmosphere%2C%20minimalist%20cream%20background%2C%20gentle%20smile&width=200&height=200&seq=author-4&orientation=squarish',
    date: '2026-08-03',
    views: 28760,
    likes: 5530,
    image: 'https://readdy.ai/api/search-image?query=a%20fluffy%20orange%20tabby%20cat%20relaxing%20on%20a%20cozy%20modern%20cat%20tree%20near%20sunny%20window%2C%20warm%20natural%20lighting%2C%20minimalist%20scandinavian%20interior%2C%20cream%20walls%2C%20peaceful%20home%20atmosphere%2C%20soft%20focus%20background&width=1200&height=675&seq=article-4&orientation=landscape',
    tags: ['猫咪', '居家环境', '萌宠', '宠物养护'],
  },
  {
    id: 'article-5',
    title: '东京甜品店巡礼：不可错过的5家网红蜜桃甜点',
    slug: 'tokyo-peach-desserts',
    excerpt: '东京作为亚洲甜品之都，有着数不清的美味甜点店。这次蜜桃美食小队专程飞往东京，为大家精选了5家用蜜桃制作的神仙甜点，每一口都是甜蜜暴击。',
    content: `<p>东京，这座永不疲倦的城市，对于甜品爱好者来说简直就是天堂。从传统的和果子到新潮的法式甜点，从百年老店到网红打卡店，每一家都有让人心动的理由。</p>
    <p>这一次，我们以"蜜桃"为主题，精选了5家必去的甜品店，每一家都让人幸福感爆棚。</p>
    <h3>1. 桃の実（自由之丘）</h3>
    <p>这家藏匿在自由之丘小巷中的甜品店，招牌是"整颗蜜桃芭菲"。使用当季最饱满的白桃，搭配手工香草冰淇淋和酥脆的杏仁碎，层次丰富到令人惊艳。每份芭菲都会用到整整一颗新鲜蜜桃，诚意满满。</p>
    <h3>2. Fruits Parlor（表参道）</h3>
    <p>位于表参道的水果甜品专门店，他们家的"蜜桃千层酥"是Instagram上的爆款。薄如蝉翼的酥皮夹着轻盈的蜜桃奶油，顶部铺满新鲜蜜桃切片，颜值和口味双在线。</p>
    <h3>3. 甘味処 桃缶（浅草）</h3>
    <p>想要体验传统日式蜜桃甜点，一定要来这家位于浅草的老铺。招牌的"蜜桃寒天"用寒天冻搭配蜜桃糖水，清凉甘甜，是夏日消暑的绝佳选择。</p>
    <h3>4. Peach Blossom（代官山）</h3>
    <p>代官山的网红甜品店，主打"蜜桃戚风蛋糕"。松软的戚风蛋糕体里夹着大块的蜜桃果肉和轻盈的鲜奶油，每一口都能吃到蜜桃的鲜甜。建议提前预约，经常下午就售罄了。</p>
    <h3>5. La Peche（银座）</h3>
    <p>银座的高级法式甜品店，主厨曾在巴黎米其林三星餐厅工作。必点的"蜜桃慕斯"造型精美，口感丝滑，搭配蜜桃果酱夹心，绝对是甜品中的艺术品。</p>`,
    category: 'meishi',
    categoryName: '美食',
    author: '蜜桃美食小队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20food%20blogger%20portrait%2C%20bright%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20professional%20headshot%2C%20friendly%20expression&width=200&height=200&seq=author-5&orientation=squarish',
    date: '2026-08-01',
    views: 67200,
    likes: 9102,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20assortment%20of%20peach%20desserts%20on%20elegant%20plates%2C%20japanese%20patisserie%20style%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20marble%20surface%2C%20fresh%20peaches%20as%20decoration%2C%20food%20photography%2C%20warm%20atmosphere&width=1200&height=675&seq=article-5&orientation=landscape',
    tags: ['东京', '甜品', '蜜桃', '美食探店'],
  },
  {
    id: 'article-6',
    title: '大理慢生活：在苍山洱海间寻找甜蜜灵感',
    slug: 'dali-slow-life',
    excerpt: '大理，一个让时间慢下来的地方。苍山的雪、洱海的月、古城的风，每一处风景都在诉说着属于大理的甜蜜故事。跟着我们的镜头，一起感受大理的温柔时光。',
    content: `<p>如果你觉得城市的节奏太快，那大理一定是最好的解药。这座被苍山洱海环绕的小城，有着让人放下一切烦恼的魔力。</p>
    <p>上个月我在大理住了一周，每天就是晒太阳、喝咖啡、逛古城、看日落。这种慢到骨子里的生活方式，让我重新找回了对生活的热爱。</p>
    <h3>住在大理：选一间看得见洱海的民宿</h3>
    <p>这次我选择了洱海边的一家白族风格民宿。每天早上被洱海的晨光唤醒，推开窗就能看到苍山如黛、洱海如镜，这种体验无法用言语形容。</p>
    <p>民宿老板是一对年轻夫妻，热情好客，还给我们做了地道的白族三道茶。苦茶、甜茶、回味茶，三杯茶诠释了人生的三种味道。</p>
    <h3>玩在大理：古城慢逛 & 环洱海骑行</h3>
    <p>大理古城不大，但每一条巷子都值得慢慢逛。人民路上有各种手工艺品店、独立书店和小众咖啡馆，走到哪算哪，这种没有目的的闲逛反而最惬意。</p>
    <p>环洱海骑行是必体验的项目。租一辆电动车，沿着环海路一路骑行，看到好看的风景就停下来拍照，累了就在路边的咖啡馆歇歇脚，这才是大理正确的打开方式。</p>
    <h3>吃在大理：不可错过的地道美食</h3>
    <p>大理的美食融合了白族特色和云南风味。推荐一定要试试：乳扇（烤着吃最香）、大理酸辣鱼、喜洲粑粑和过桥米线。古城里的小吃摊和本地人推荐的餐馆，往往比网红店更地道。</p>`,
    category: 'lvxing',
    categoryName: '旅行',
    author: '蜜桃旅行家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20gentle%20smile%2C%20outdoor%20soft%20lighting%2C%20minimalist%20warm%20background%2C%20travel%20photographer%20style%2C%20friendly%20expression%2C%20peach%20warm%20tones&width=200&height=200&seq=author-2&orientation=squarish',
    date: '2026-07-28',
    views: 45300,
    likes: 6890,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20dali%20erhai%20lake%20landscape%20with%20cangshan%20mountains%20in%20background%2C%20warm%20sunset%20golden%20light%2C%20serene%20water%20reflection%2C%20soft%20pastel%20sky%20colors%2C%20peaceful%20travel%20photography%2C%20cream%20warm%20tones&width=1200&height=675&seq=article-6&orientation=landscape',
    tags: ['大理', '洱海', '慢生活', '云南旅行'],
  },
];

export const creators = [
  {
    id: 'creator-1',
    name: '蜜桃小厨娘',
    followers: 526000,
    description: '热爱美食、热爱生活的90后小厨娘，用镜头记录每一道甜蜜料理。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20professional%20headshot%20style%2C%20gentle%20expression%2C%20warm%20peach%20tones&width=200&height=200&seq=author-1&orientation=squarish',
  },
  {
    id: 'creator-2',
    name: '蜜桃旅行家',
    followers: 438000,
    description: '走遍世界的旅行博主，带你发现地球上每一个甜蜜角落。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20gentle%20smile%2C%20outdoor%20soft%20lighting%2C%20minimalist%20warm%20background%2C%20travel%20photographer%20style%2C%20friendly%20expression%2C%20peach%20warm%20tones&width=200&height=200&seq=author-2&orientation=squarish',
  },
  {
    id: 'creator-3',
    name: '蜜桃时尚志',
    followers: 389000,
    description: '前时尚杂志编辑，专注日常穿搭与生活美学，让每一天都穿出甜蜜感。',
    avatar: 'https://readdy.ai/api/search-image?query=stylish%20young%20asian%20woman%20portrait%2C%20elegant%20minimal%20style%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20fashionable%20headshot%2C%20warm%20peach%20tones%2C%20confident%20gentle%20expression&width=200&height=200&seq=author-3&orientation=squarish',
  },
  {
    id: 'creator-4',
    name: '蜜桃喵星人',
    followers: 512000,
    description: '三只猫咪的铲屎官，分享猫咪日常和宠物养护小知识，治愈你的每一天。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20with%20cat%2C%20warm%20friendly%20portrait%2C%20soft%20indoor%20lighting%2C%20cozy%20home%20atmosphere%2C%20minimalist%20cream%20background%2C%20gentle%20smile&width=200&height=200&seq=author-4&orientation=squarish',
  },
  {
    id: 'creator-5',
    name: '甜心手作人',
    followers: 276000,
    description: '手工达人，用灵巧双手创造甜蜜小物，让生活充满手作的温度。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20with%20crafts%2C%20warm%20smile%2C%20soft%20indoor%20lighting%2C%20cozy%20workshop%20background%2C%20minimalist%20cream%20texture%2C%20friendly%20expression&width=200&height=200&seq=creator-5&orientation=squarish',
  },
  {
    id: 'creator-6',
    name: '蜜桃健身日记',
    followers: 345000,
    description: '运动生活方式博主，分享健康美食和健身日常，一起成为更好的自己。',
    avatar: 'https://readdy.ai/api/search-image?query=fitness%20young%20woman%20portrait%2C%20healthy%20glowing%20skin%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20energetic%20confident%20expression%2C%20athletic%20style&width=200&height=200&seq=creator-6&orientation=squarish',
  },
];

export const heroSlides = [
  {
    id: 'hero-1',
    title: '甜蜜生活，从蜜桃开始',
    subtitle: '记录每一个值得珍藏的甜蜜瞬间',
    image: 'https://readdy.ai/api/search-image?query=soft%20dreamy%20peach%20colored%20abstract%20background%20with%20gentle%20gradients%20and%20floating%20delicate%20petals%2C%20warm%20cream%20and%20coral%20tones%2C%20ethereal%20atmosphere%2C%20minimalist%20elegant%20composition%2C%20light%20airy%20texture%2C%20artistic%20photography%20with%20soft%20bokeh%20effects&width=1800&height=900&seq=hero-main-01&orientation=landscape',
  },
];

export const featureVideos = [
  {
    id: 'feat-1',
    slug: 'summer-peach-drinks',
    title: '蜜桃奶油蛋糕制作全过程',
    author: '蜜桃小厨娘',
    views: 128000,
    likes: 15600,
    duration: '08:32',
    thumbnail: 'https://readdy.ai/api/search-image?query=beautiful%20peach%20cream%20cake%20being%20decorated%20on%20marble%20counter%2C%20soft%20natural%20lighting%2C%20warm%20cream%20background%2C%20food%20photography%20style%2C%20elegant%20composition%2C%20delicate%20details&width=600&height=400&seq=feat-1&orientation=landscape',
  },
  {
    id: 'feat-2',
    slug: 'kyoto-travel-guide',
    title: '北海道冬季绝美雪景',
    author: '蜜桃旅行家',
    views: 235000,
    likes: 28900,
    duration: '12:05',
    thumbnail: 'https://readdy.ai/api/search-image?query=beautiful%20hokkaido%20winter%20snow%20landscape%20with%20traditional%20houses%2C%20soft%20snowfall%2C%20warm%20golden%20lights%20from%20windows%2C%20serene%20atmosphere%2C%20cream%20white%20and%20warm%20amber%20tones%2C%20dreamy%20winter%20scene&width=600&height=400&seq=feat-2&orientation=landscape',
  },
  {
    id: 'feat-3',
    slug: 'autumn-fashion-peach',
    title: '一周七天不重样穿搭',
    author: '蜜桃时尚志',
    views: 187000,
    likes: 22300,
    duration: '06:18',
    thumbnail: 'https://readdy.ai/api/search-image?query=seven%20elegant%20outfits%20displayed%20on%20minimalist%20rack%2C%20soft%20neutral%20and%20peach%20tones%2C%20natural%20lighting%20from%20window%2C%20clean%20cream%20wall%20background%2C%20fashion%20editorial%20style%2C%20organized%20composition&width=600&height=400&seq=feat-3&orientation=landscape',
  },
  {
    id: 'feat-4',
    slug: 'cat-home-environment',
    title: '小奶猫的第一次洗澡',
    author: '蜜桃喵星人',
    views: 352000,
    likes: 45600,
    duration: '04:55',
    thumbnail: 'https://readdy.ai/api/search-image?query=adorable%20tiny%20kitten%20getting%20first%20bath%20in%20small%20basin%2C%20warm%20bathroom%20lighting%2C%20soft%20cream%20towels%2C%20gentle%20hands%2C%20cute%20wet%20fluffy%20expression%2C%20heartwarming%20pet%20photography&width=600&height=400&seq=feat-4&orientation=landscape',
  },
];

export const faqs = [
  {
    question: '蜜桃视频是什么？',
    answer: '蜜桃视频是一个专注甜蜜生活方式的创意短视频平台，汇聚美食、旅行、时尚、萌宠等多元内容。我们致力于为创作者和用户打造一个充满桃气与活力的内容社区，让每一帧都充满甜蜜感。',
  },
  {
    question: '如何在蜜桃视频上发布内容？',
    answer: '注册成为蜜桃视频创作者后，你可以通过手机App或网页端上传你的短视频作品。我们支持最长15分钟的视频内容，并提供丰富的编辑工具和滤镜，让你的创作更加出彩。',
  },
  {
    question: '蜜桃视频的内容分类有哪些？',
    answer: '目前蜜桃视频主要涵盖四大内容板块：美食、旅行、时尚和萌宠。每个板块都有专业的运营团队进行内容精选和推荐，帮助优质内容获得更多曝光。同时我们也在不断扩展新的内容品类。',
  },
  {
    question: '蜜桃视频如何保证内容质量？',
    answer: '我们建立了严格的内容审核机制，采用AI智能审核+人工复核的双重保障，确保平台内容的健康、积极、优质。同时，我们通过算法推荐和编辑精选相结合的方式，让真正有价值的甜蜜内容被更多人看到。',
  },
  {
    question: '蜜桃视频是否免费使用？',
    answer: '蜜桃视频基础功能完全免费。用户可以免费浏览所有内容、关注创作者、点赞收藏喜欢的视频。创作者也可以免费发布作品。我们还会定期推出创作激励计划，奖励优秀的原创内容创作者。',
  },
];

export const aboutInfo = {
  brandStory: `蜜桃视频诞生于2024年，由一群热爱生活、热爱创作的年轻人共同发起。我们相信，生活中每一个甜蜜的瞬间都值得被记录和分享，每一份真挚的热爱都应该被看见。

"蜜桃"这个名字，源自我们对生活的理解——生活就像一颗蜜桃，外表粉嫩温柔，内在甜美多汁。我们希望这个平台能像蜜桃一样，给每个人带来甜蜜和温暖。

从最初的十几位创作者，到如今汇聚了数万名来自全国各地的优质创作者；从最初的美食板块，到如今涵盖美食、旅行、时尚、萌宠等多元内容品类——蜜桃视频的每一步成长，都离不开每一位创作者和用户的支持与热爱。

未来，蜜桃视频将继续深耕甜蜜生活方式内容，不断优化产品体验，为创作者提供更好的创作工具和变现机会，为用户带来更多优质的甜蜜内容。`,
  milestones: [
    { year: '2024年3月', title: '蜜桃视频正式上线', description: '专注甜蜜生活方式的短视频平台诞生，首批100位创作者入驻。' },
    { year: '2024年8月', title: '用户突破100万', description: '凭借优质的美食和旅行内容，蜜桃视频快速积累了第一批忠实用户。' },
    { year: '2025年1月', title: '时尚与萌宠板块上线', description: '内容品类扩展至四大板块，创作者数量突破5000人。' },
    { year: '2025年6月', title: '用户突破500万', description: '平台进入快速增长期，日活跃用户超过80万。' },
    { year: '2025年12月', title: '创作者激励计划启动', description: '推出千万级创作者基金，支持优质原创内容的创作与传播。' },
    { year: '2026年3月', title: '用户突破1000万', description: '蜜桃视频成为国内领先的生活方式短视频平台之一。' },
  ],
  testimonials: [
    {
      name: '小甜',
      role: '美食创作者',
      content: '在蜜桃视频上分享我的烘焙作品已经一年多了，认识了很多志同道合的朋友。平台的创作氛围特别好，每次看到粉丝们的暖心评论，就觉得所有的付出都很值得。',
      avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20friendly%20portrait%2C%20gentle%20expression&width=200&height=200&seq=test-1&orientation=squarish',
    },
    {
      name: '旅行者阿杰',
      role: '旅行创作者',
      content: '蜜桃视频让我找到了展示旅行故事的舞台。平台对旅行内容的推荐机制很公平，好的内容真的能被看到。现在我每到一个新地方，第一件事就是打开蜜桃视频记录。',
      avatar: 'https://readdy.ai/api/search-image?query=young%20man%20portrait%20with%20confident%20smile%2C%20outdoor%20soft%20lighting%2C%20minimalist%20warm%20background%2C%20travel%20enthusiast%20style&width=200&height=200&seq=test-2&orientation=squarish',
    },
    {
      name: '糖糖',
      role: '忠实用户',
      content: '每天睡前刷蜜桃视频已经成了我的习惯。特别喜欢美食板块，跟着很多博主学会了做好多甜品。这个平台的内容质量真的很高，推荐给所有热爱生活的朋友。',
      avatar: 'https://readdy.ai/api/search-image?query=young%20woman%20portrait%20with%20bright%20smile%2C%20warm%20indoor%20lighting%2C%20minimalist%20cream%20background%2C%20happy%20friendly%20expression&width=200&height=200&seq=test-3&orientation=squarish',
    },
  ],
  contact: {
    email: 'hello@mitao-video.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T1 12层',
    wechat: '蜜桃视频官方',
    weibo: '@蜜桃视频',
  },
};